// Claude: extracted from RFXDetail — buyer profile right-side drawer + notes modal 18-04-2026
import React, { useState } from "react";
import {
  Box,
  Flex,
  Text,
  Spinner,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
  DrawerCloseButton,
} from "@chakra-ui/react";
import { Modal } from "antd";
import NotesModal from "../Modals/NotesModal";

interface BuyerProfileDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  buyerProfile: any;
  buyerAssets: any[];
  profileLoading: boolean;
  notesBody: string;
  onNotesUpdated: () => void;
}

const BuyerProfileDrawer: React.FC<BuyerProfileDrawerProps> = ({
  isOpen,
  onClose,
  buyerProfile,
  buyerAssets,
  profileLoading,
  notesBody,
  onNotesUpdated,
}) => {
  const [notesOpen, setNotesOpen] = useState(false);

  const handleNotesClose = () => {
    setNotesOpen(false);
    onNotesUpdated();
  };

  return (
    <>
      <Drawer isOpen={isOpen} onClose={onClose} placement="right" size="md">
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader fontSize="md" fontWeight={700} pb={1} px={4}>
            {buyerProfile?.buyerCompanyName}
          </DrawerHeader>
          <DrawerBody overflowY="auto" px={4} pb={6}>
            {profileLoading ? (
              <Flex justifyContent="center" py={10}><Spinner size="sm" color="#0E122F" /></Flex>
            ) : buyerProfile && (
              <>
                {buyerProfile.buyerPersonCountry && (
                  <Text fontSize="12px" color="gray.500" mb={1}>{buyerProfile.buyerPersonCountry}</Text>
                )}
                {buyerProfile.buyerCompanyWebsite && (
                  <Text fontSize="12px" color="#1565C0" textDecoration="underline" cursor="pointer" mb={2}
                    onClick={() => window.open(buyerProfile.buyerCompanyWebsite, "_blank")}>
                    {buyerProfile.buyerCompanyWebsite}
                  </Text>
                )}
                {buyerProfile.buyerCompanyInfo && (
                  <Box mb={4}>
                    <Text fontSize="11px" fontWeight={600} color="gray.500" mb={1}>About</Text>
                    <Text fontSize="13px" color="gray.700" lineHeight="1.5">{buyerProfile.buyerCompanyInfo}</Text>
                  </Box>
                )}
                {/* Claude: Company Type badges 14-04-2026 */}
                {buyerProfile.buyerCompanyType?.length > 0 && (
                  <Box mb={4}>
                    <Text fontSize="11px" fontWeight={600} color="gray.500" mb={1}>Company Type</Text>
                    <Flex gap={1} flexWrap="wrap">
                      {buyerProfile.buyerCompanyType.map((t: string, i: number) => (
                        <span key={i} style={{ padding: "2px 8px", backgroundColor: "#E3F2FD", color: "#1565C0", borderRadius: "3px", fontSize: "11px" }}>
                          {t === "Others" && buyerProfile.buyerCompanyTypeOther ? buyerProfile.buyerCompanyTypeOther : t}
                        </span>
                      ))}
                    </Flex>
                  </Box>
                )}

                <Box mb={4}>
                  {notesBody ? (
                    <>
                      <Text fontSize="11px" fontWeight={600} color="gray.500" mb={1}>Notes</Text>
                      <Text fontSize="13px" color="gray.700" lineHeight="1.5">{notesBody}</Text>
                    </>
                  ) : (
                    <Text fontSize="12px" color="#1565C0" textDecoration="underline" cursor="pointer"
                      onClick={() => setNotesOpen(true)}>
                      Add Notes
                    </Text>
                  )}
                </Box>

                <Text fontSize="12px" fontWeight={600} color="gray.600" mb={2}>
                  Digital Assets ({buyerAssets.length})
                </Text>
                {buyerAssets.length === 0 ? (
                  <Text fontSize="sm" color="gray.400">No assets listed.</Text>
                ) : (
                  <Flex direction="column" gap={3}>
                    {buyerAssets.map((asset: any) => (
                      <Box key={asset._id} p={3} bg="gray.50" borderRadius="10px"
                        border="1px solid" borderColor="gray.200"
                        cursor="pointer"
                        _hover={{ bg: "#F1F8E9", borderColor: "#A5D6A7" }}
                        onClick={() => window.open(asset.assetUrl, "_blank")}>
                        <Text fontSize="13px" fontWeight={600} color="#0E122F" lineHeight="1.4">{asset.assetTitle}</Text>
                        {asset.assetType && (
                          <Text fontSize="10px" color="#2E7D32" fontWeight={500} mt={0.5}>{asset.assetType}</Text>
                        )}
                        {asset.assetSummary && (
                          <Text fontSize="11px" color="gray.500" mt={1} noOfLines={2}>{asset.assetSummary}</Text>
                        )}
                      </Box>
                    ))}
                  </Flex>
                )}
              </>
            )}
          </DrawerBody>
        </DrawerContent>
      </Drawer>

      {/* Claude: notes modal — zIndex above drawer 02-Apr-2026 */}
      <Modal closeIcon={null} footer={null} title={null} open={notesOpen} zIndex={1500}
        onOk={handleNotesClose} onCancel={handleNotesClose}>
        <NotesModal
          forUser={buyerProfile?._id ?? ""}
          companyName={buyerProfile?.buyerCompanyName ?? ""}
          handleCloseModal={handleNotesClose}
        />
      </Modal>
    </>
  );
};

export default BuyerProfileDrawer;
